import './index.css'
import React from 'react';
import { Form, Input, Button, Typography, Modal, Row, Col, Card, Space } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom'
import { LockOutlined, MailOutlined, ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import API_ROUTES from '../../api'
import { syncProfileToLocalStorage } from '../../utils/authProfile';
import GsrdWch from '../../components/GsrdWch';

const { Title, Text, Link, Paragraph } = Typography;

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const [form] = Form.useForm();
    const redirectAfterLogin = location.state?.from && location.state.from !== '/login'
        ? location.state.from
        : '/display';

    const onFinish = (values) => {
        axios
            .post(API_ROUTES.api_login, {
                userName: values.email,
                password: values.password,
            })
            .then(function (response) {
                if (response.data.code === 500) {
                    Modal.error({ 
                        title: 'Login Failed',
                        content: response.data.msg 
                    });
                }
                if (response.data.code === 200) {
                    localStorage.setItem('userInfo', response.data.data.userInfo)
                    // 登录后统一写入账号审核状态，后续受限页面会再次刷新服务端状态
                    syncProfileToLocalStorage(response.data.data)
                    // 登录成功后优先回到触发登录的页面；右上角直接登录默认回首页
                    navigate(redirectAfterLogin, { replace: true });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                Modal.error({ 
                    title: 'Error',
                    content: error.response?.data?.msgDes || "Login failed. Please check your credentials." 
                });
            });
    };

    return (
        <div className="shared-auth-page" style={{ backgroundColor: '#f0f5ff', minHeight: '100vh', paddingBottom: '80px' }}>
            {/* Header Section */}
            <div className="shared-auth-hero-banner" style={{
                height: '300px',
                padding: '60px 20px',
                textAlign: 'center',
                color: 'white',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Button 
                    type="text" 
                    icon={<ArrowLeftOutlined />} 
                    style={{ color: 'white', position: 'absolute', left: '20px', top: '20px' }}
                    onClick={() => navigate('/display')}
                >
                    Home
                </Button>
                <div style={{ marginBottom: '20px' }}>
                     <img
                        src={"https://gsrd-server.tos-cn-beijing.volces.com/gsrdlogonowch%20(2).png"}
                        style={{ height: '60px', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))' }}
                        alt="GSRD Logo"
                    />
                </div>
                <Title level={1} style={{ color: 'white', margin: 0, fontWeight: 800, fontSize: '32px' }}>Welcome Back</Title>
                <Paragraph style={{ color: 'rgba(255,255,255,0.8)', marginTop: '8px', fontSize: '16px' }}>
                    Access the <GsrdWch /> Portal to manage your research data.
                </Paragraph>
            </div>

            {/* Login Card */}
            <div className="shared-auth-card-wrap">
                <Card 
                    bordered={false} 
                    style={{ 
                        width: '100%', 
                        maxWidth: '440px', 
                        borderRadius: '24px', 
                        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '40px' }}
                >
                    <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                        <div style={{ 
                            width: '64px', 
                            height: '64px', 
                            background: '#f0f7ff', 
                            borderRadius: '50%', 
                            margin: '0 auto 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#055878',
                            fontSize: '28px'
                        }}>
                            <UserOutlined />
                        </div>
                        <Title level={3} style={{ color: '#055878', margin: 0 }}>Login</Title>
                    </div>

                    <Form
                        name="login"
                        layout="vertical"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        form={form}
                        size="large"
                        requiredMark={false}
                    >
                        <Form.Item
                            label={<Text strong>Email Address</Text>}
                            name="email"
                            rules={[{ required: true, message: 'Please input your email!' }]}
                        >
                            <Input 
                                prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Enter your email" 
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <Form.Item
                            label={<Text strong>Password</Text>}
                            name="password"
                            rules={[{ required: true, message: 'Please input your password!' }]}
                            style={{ marginBottom: '8px' }}
                        >
                            <Input.Password 
                                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Enter your password" 
                                style={{ borderRadius: '10px' }}
                            />
                        </Form.Item>

                        <div style={{ textAlign: 'right', marginBottom: '24px' }}>
                            <Link onClick={() => navigate('/forgetPwd')} style={{ color: '#13769a', fontSize: '14px', fontWeight: 500 }}>
                                Forgot password?
                            </Link>
                        </div>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                style={{
                                    height: '54px',
                                    background: 'linear-gradient(135deg, #055878 0%, #13769a 100%)',
                                    border: 'none',
                                    borderRadius: '27px',
                                    fontWeight: '700',
                                    fontSize: '18px',
                                    boxShadow: '0 8px 20px rgba(5, 88, 120, 0.25)'
                                }}
                            >
                                Log In
                            </Button>
                        </Form.Item>
                    </Form>

                    <div style={{ textAlign: 'center', marginTop: '16px' }}>
                        <Space>
                            <Text type="secondary">New to <GsrdWch />?</Text>
                            <Link onClick={() => navigate('/registFirstStep')} style={{ color: '#055878', fontWeight: 600 }}>
                                Create an account
                            </Link>
                        </Space>
                    </div>
                </Card>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <Text type="secondary" style={{ fontSize: '13px' }}>
                    &copy; 2024 Genome Sequencing of Rare Disease Project
                </Text>
            </div>
        </div>
    )
}
